import { z } from 'zod';
export const otVisitValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        PlanOfCare: z.boolean().refine((value) => !!value, { message: 'section has errors' }),
        subjective: z.object({
            patientReporting: z.string().optional(),
            functionalStability: z.string().optional(),
            stabilityBarriers: z.string().optional(),
            bp: z.object({
                rest: z.object({
                    diastolic: z.string().optional(),
                    systolic: z.string().optional(),
                }),
                activity: z.object({
                    diastolic: z.string().optional(),
                    systolic: z.string().optional(),
                }),
            }),
            sp: z.object({
                rest: z.string().optional(),
                activity: z.string().optional(),
            }),
            heartRate: z.object({
                rest: z.string().optional(),
                activity: z.string().optional(),
            }),
            respiration: z.object({
                rest: z.string().optional(),
                activity: z.string().optional(),
            }),
        }),
        objective: z.object({
            affecting: z.array(z.string()).optional(),
            affectingSpecify: z.string().optional(),
        }),
        hep: z.object({
            progression: z.string().optional(),
            reviewed: z.string().optional(),
            advanced: z.string().optional(),
            modified: z.string().optional(),
            ptAction: z.array(z.string()).optional(),
            ptActionSpecify: z.string().optional(),
            understanding: z.string().optional(),
            properTechnique: z.array(z.string()).optional(),
        }),
        bodyExercise: z.object({
            cervical: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            shoulder: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            elbow: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            forearm: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            wrist: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            handFingers: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            impressions: z.string().optional(),
        }),
        otcgEducation: z.object({
            education: z.array(z.string()).optional(),
            dischargePlanning: z.string().optional(),
            learningStatus: z.string().optional(),
            other: z.string().optional(),
        }),
        transfers: z.object({
            bed: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            sitStand: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            toilet: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            chair: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            floor: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            shower: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            car: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
        }),
        adl: z.object({
            grooming: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            toileting: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            bathing: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            dressingUE: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            dressingLE: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            socks: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
        }),
        iadls: z.object({
            usingPhones: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            shopping: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            foodPrep: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            houseKeeping: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            laundry: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            transport: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            takingMed: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            finances: z
                .object({
                goal: z.string().optional(),
                plof: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
        }),
        motivation: z.object({
            motivation: z.array(z.string()).optional(),
            motivationOther: z.string().optional(),
        }),
        session: z.object({
            tolerance: z.array(z.string()).optional(),
            toleranceOther: z.string().optional(),
        }),
        overallProgress: z.object({
            progress: z.array(z.string()).optional(),
            progressOther: z.string().optional(),
        }),
        reasonContinuePT: z.object({
            reason: z.array(z.string()).optional(),
            reasonOther: z.string().optional(),
        }),
        nextVisitPlans: z.object({
            plans: z.array(z.string()).optional(),
            plansOther: z.string().optional(),
        }),
        bodyExercisePlan: z.object({
            cervical: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            shoulder: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            elbow: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            forearm: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            wrist: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            handFingers: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
        }),
        coordination: z.object({
            nameTitle: z.string().optional(),
            reviewed: z.string().optional(),
            planned: z.string().optional(),
        }),
        misc: z.object({
            nextAppointment: z.string().optional(),
            notes: z.array(z.string()).optional(),
            notesOther: z.string().optional(),
        }),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
